import React, { useEffect, useRef, useState } from "react";
import { DataGrid, GridCellModes } from "@mui/x-data-grid";
import {
  Alert,
  Button,
  createTheme,
  Snackbar,
  ThemeProvider,
  Typography,
} from "@mui/material";
import {
  getCurrentMonthDatesAsia,
  getDatesFromMonthYearAsia,
  getUser,
} from "../helpers";
import api from "../axiosConfig";
import { exportToExcel } from "react-json-to-excel";
import { LoadingButton } from "@mui/lab";
import AddNewScheme from "../components/AddNewScheme";
import { useModalContext } from "../ModalContext";

function DataGridWithEdit({
  open,
  editValue,
  handleClose,
  callValue,
  updateRowData,
  rowColumn,
  setCallValue,
  setCustomOpenModal,
  monthYear,
  columns,
  dayLevelButton,
  page,
  pricelist02,
  setSnackbarAlertMessage,
  setSnackbarAlertSeverity,
  setSnackbarAlertOpen,
  setEditedTotalRevValue,
  setIsTotalRevEdited,
  isTotalRevEdited,
  editedTotalRevValue,
  rows,
  setRows,
  totalRevValue,
  setTotalRevValue,
  setEditedMonthOutLook,
  type
}) {
  // const [rows, setRows] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  // const [totalRevValue, setTotalRevValue] = useState(0);
  const [totalQtyValue, setTotalQtyValue] = useState(0);
  const [isDataAvailable, setIsDataAvailable] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const [baselineRateValue, setBaselineRateValue] = useState(0);
  const [dataExport, setDataExport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [schemeTypeData, setSchemeTypeData] = useState(false);
  const [isQtyPercentEdited, setIsQtyPercentEdited] = React.useState(false);
  const [correctionUpdateButton, setCorrectionUpdateButton] = useState(false);
  const [totalRevEdited, setTotalRevEdited] = useState(false);
  const [enteredQtyImpact, setEnteredQtyImpact] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [hasUserEdited, setHasUserEdited] = useState(false);
  const initialTotalRevValue = useRef(totalRevValue);
  const {
    isLoading,

    setNewSchemeModalOpen,
    currency,
  } = useModalContext();
  const user = getUser();

  // handle alert cancel
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleOpenModal = (rowData) => {
    setSchemeTypeData(rowData);
    setNewSchemeModalOpen(true);
  };
  const handleCloseModal = () => setNewSchemeModalOpen(false);

  const handleClearNewValues = () => {
    setIsTotalRevEdited("");
  };

  useEffect(() => {
    if (open) {
      setEditedTotalRevValue(null); // Reset edited value when modal closes
      setIsTotalRevEdited(false); // Reset edit flag
    }
  }, [open]);

  // console.log(callValue, "callValue");

  // useEffect(() => {
  //   const correctionEntry = editValue?.find(
  //     (entry) => entry.Request_Type === "Correction"
  //   );

  //   const isQtyImpactSame =
  //     correctionEntry &&
  //     Number(correctionEntry.Qty_Impact) * 100 === Number(enteredQtyImpact);

  //       const isTotalRevSame =
  //     Number(editedTotalRevValue) === Number(initialTotalRevValue.current);

  //     console.log(isTotalRevSame, "isTotalRevSame")
  //     console.log(initialTotalRevValue, "initialTotalRevValue")
  //     console.log(editedTotalRevValue, "editedTotalRevValue")
  //     console.log(totalRevValue, "totalRevValue")

  //   if (isQtyImpactSame) {
  //     console.error(
  //       "The entered Correction value is the same as the existing value."
  //     );
  //     setSnackbarMessage(
  //       "The entered Correction value is the same as the existing value."
  //     );
  //     setSnackbarSeverity("warning");
  //     setSnackbarOpen(true);
  //     setCorrectionUpdateButton(true); // Disable button
  //   } else if (isQtyPercentEdited) {
  //     // Condition 1: Enable the button if the user edits qtyPercent (highest priority)
  //     setCorrectionUpdateButton(false);
  //   } else if (correctionEntry) {
  //     // Condition 2: Disable the button if a "Correction" entry exists
  //     setCorrectionUpdateButton(true);
  //   } else {
  //     // Condition 3: Disable the button if no "Correction" entry exists
  //     setCorrectionUpdateButton(true);
  //   }
  // }, [editValue, isQtyPercentEdited, enteredQtyImpact]);

  // const isTotalRevSame =
  // Number(editedTotalRevValue) === Number(initialTotalRevValue.current);

  // useEffect(() => {
  //   if (!editedTotalRevValue) return;

  //   const isTotalRevSame =
  //     Number(editedTotalRevValue) === Number(initialTotalRevValue.current);

  //   if (isTotalRevSame) {
  //     console.error("Same value error");
  //     setSnackbarMessage("Value matches original total revenue");
  //     setSnackbarSeverity("warning");
  //     setSnackbarOpen(true);
  //     setTotalRevEdited(true);
  //   } else {
  //     setTotalRevEdited(false);
  //   }
  // }, [editedTotalRevValue, hasUserEdited]);

  useEffect(() => {
    if (!open) return;

    // setIsLoading(true);
    // const timer = setTimeout(() => {
    const defaultRows = [
      {
        id: 1,
        type: "Baseline",
        ratePercent: "",
        rateValue: "",
        qtyPercent: "",
        qtyValue: "",
        revValue: "",
        revPercent: "",
        cost: "",
      },

      {
        id: 2,
        type: "On Invoice",
        ratePercent: "",
        rateValue: "",
        qtyPercent: "",
        qtyValue: "",
        revValue: "",
        revPercent: "",
        cost: "",
        Actions: "",
      },
      {
        id: 3,
        type: "Off Invoice",
        ratePercent: "",
        rateValue: "",
        qtyPercent: "",
        qtyValue: "",
        revValue: "",
        revPercent: "",
        cost: "",
        Actions: "",
      },
      {
        id: 4,
        type: "Visibility",
        ratePercent: "",
        rateValue: "",
        qtyPercent: "",
        qtyValue: "",
        revValue: "",
        revPercent: "",
        cost: "",
      },
      {
        id: 5,
        type: "Sub total",
        ratePercent: "",
        rateValue: "",
        qtyPercent: "",
        qtyValue: "",
        revValue: "",
        revPercent: "",
        cost: "",
      },
      {
        id: 6,
        type: "Correction",
        ratePercent: "",
        rateValue: "",
        qtyPercent: "",
        qtyValue: "",
        revValue: "",
        revPercent: "",
        cost: "",
      },
      {
        id: 7,
        type: "Total",
        ratePercent: "",
        rateValue: "",
        qtyPercent: "",
        qtyValue: "",
        revValue: "",
        revPercent: "",
        cost: "",
      },
    ];

    //  the `Request_Type` to match the default rows
    const mapRequestType = {
      OnInv: "On Invoice",
      OffInv: "Off Invoice",
      Baseline: "Baseline",
      Correction: "Correction",
      Visibility: "Visibility",
    };

    const BaseCorrectionQtyValue =
      editValue
        ?.filter(
          (item) =>
            mapRequestType[item.Request_Type] === "Baseline" ||
            mapRequestType[item.Request_Type] === "Correction"
        )
        .reduce((sum, item) => sum + (Math.round(item.Qty) || 0), 0) || 0;

    const BaseCorrectionRevValue =
      editValue
        ?.filter(
          (item) =>
            mapRequestType[item.Request_Type] === "Baseline" ||
            mapRequestType[item.Request_Type] === "Correction"
        )
        .reduce((sum, item) => sum + (Math.round(item.Sales) || 0), 0) || 0;

    const calculatedRateValue =
      BaseCorrectionRevValue !== 0
        ? (BaseCorrectionRevValue / BaseCorrectionQtyValue).toFixed(2)
        : "0.00";

    setBaselineRateValue(calculatedRateValue);

    const baselineObj = editValue?.find(
      (item) => mapRequestType[item.Request_Type] === "Baseline"
    );
    const correctionObj = editValue?.find(
      (item) => mapRequestType[item.Request_Type] === "Correction"
    );

    const mergedRows = defaultRows
      .map((defaultRow) => {
        // Get the matching edit value from the response data
        const matchingEditValue = editValue?.find(
          (item) => mapRequestType[item.Request_Type] === defaultRow.type
        );

        // Qty Correction % = (Correction Qty / Baseline Qty)
        // OnInv Qty % = (OnInv Qty/ (Baseline Qty + Correction Qty))
        // OffInv Qty % = (OnOff Qty/ (Baseline Qty + Correction Qty))
        // visibility Qty % = (Visbility Qty/ (Baseline Qty + Correction Qty))

        // Rev Correction % = Correction Rev / Baseline Rev

        // OnInv Rev% = (OnInv Rev/ (Baseline Rev + Correction Rev))
        // OffInv Rev % = (OnOff Rev/ (Baseline Rev + Correction Rev))
        // visibility Rev % = (Visbility Rev/ (Baseline Rev + Correction Rev ))

        if (matchingEditValue) {
          let qtyPercent = "";
          let revPercent = "";
          if (matchingEditValue?.Request_Type === "Correction") {
            const correctionQty = parseFloat(correctionObj?.Qty || 0);
            const baselineQty = parseFloat(baselineObj?.Qty || 0);
            const correctionRev = parseFloat(correctionObj?.Sales || 0);
            const baselineRev = parseFloat(baselineObj?.Sales || 0);
            qtyPercent = Math.round(
              parseFloat(correctionQty / baselineQty) * 100
            );
            revPercent = `${Math.round(
              parseFloat(correctionRev / baselineRev) * 100
            )}%`;
          } else if (
            matchingEditValue?.Request_Type === "OnInv" ||
            matchingEditValue?.Request_Type === "OffInv" ||
            matchingEditValue?.Request_Type === "Visibility"
          ) {
            qtyPercent = Math.round(
              (parseFloat(matchingEditValue?.Qty || 0) /
                (parseFloat(correctionObj?.Qty || 0) +
                  parseFloat(baselineObj?.Qty || 0))) *
                100
            );
            revPercent = `${Math.round(
              (parseFloat(matchingEditValue?.Sales || 0) /
                (parseFloat(correctionObj?.Sales || 0) +
                  parseFloat(baselineObj?.Sales || 0))) *
                100
            )}%`;
          }
          return {
            id: defaultRow.id,
            type: defaultRow.type,
            ratePercent: matchingEditValue.Rate_Impact
              ? `${Math.round(
                  parseFloat(matchingEditValue.Rate_Impact) * 100
                )}%`
              : `${defaultRow.ratePercent}`,
            rateValue: matchingEditValue.Rate
              ? matchingEditValue.Rate
              : defaultRow.rateValue,
            qtyPercent: qtyPercent,
            // matchingEditValue.Qty_Impact &&
            // parseFloat(matchingEditValue.Qty_Impact) !== 0
            //   ? `${Math.round(
            //       parseFloat(matchingEditValue.Qty_Impact) * 100
            //     )}`
            //   : "",
            qtyValue: matchingEditValue.Qty
              ? Math.round(parseFloat(matchingEditValue.Qty))
              : defaultRow.qtyValue,
            revValue: matchingEditValue.Sales
              ? Math.round(parseFloat(matchingEditValue.Sales))
              : defaultRow.revValue,
            // revPercent: defaultRow.revPercent,
            revPercent: revPercent,
            cost: defaultRow.cost,
          };
        }

        if (defaultRow.type === "Baseline") {
          return {
            ...defaultRow,
            rateValue: calculatedRateValue,
          };
        }

        return defaultRow;
      })

      .filter((row) => {
        if (row.type === "Correction") return true;
        if (
          row.type === "On Invoice" ||
          row.type === "Off Invoice" ||
          row.type === "Visibility"
        )
          return true;

        const fields = [
          row.ratePercent,
          row.rateValue,
          row.qtyPercent,
          row.qtyValue,
          row.revValue,
          row.revPercent,
          row.cost,
        ];
        return fields.some(
          (value) => value !== "" && value !== null && value !== undefined
        );
      });

    if (
      mergedRows.length === 0 ||
      mergedRows.every(
        (row) => !row.rateValue || !row.qtyValue || !row.revValue
      )
    ) {
      setIsDataAvailable(false);
    } else {
      setIsDataAvailable(true);
    }
    const subTotalRateValue = mergedRows
      .reduce((sum, row) => {
        if (
          ["Baseline", "On Invoice", "Off Invoice", "Correction"].includes(
            row.type
          )
        ) {
          const value = parseFloat(row.rateValue) || 0;
          return sum + value;
        }
        return sum;
      }, 0)
      .toFixed(2);

    const subTotalRevValue = mergedRows.reduce((sum, row) => {
      if (
        ["Baseline", "On Invoice", "Off Invoice", "Correction"].includes(
          row.type
        ) &&
        row.type !== "Total"
      ) {
        return sum + (row.revValue || 0);
      }
      return sum;
    }, 0);

    const subTotalQtyValue = mergedRows.reduce((sum, row) => {
      if (
        ["Baseline", "On Invoice", "Off Invoice", "Correction"].includes(
          row.type
        ) &&
        row.type !== "Total"
      ) {
        return sum + (row.qtyValue || 0);
      }
      return sum;
    }, 0);

    // const subTotalRatePercent = Math.round(subTotalRevValue / subTotalQtyValue);

    const subtotalRow = {
      id: "subtotal",
      type: "Sub total",
      ratePercent: "",
      rateValue: subTotalRateValue,
      qtyPercent: "",
      qtyValue: subTotalQtyValue,
      revValue: subTotalRevValue,
      revPercent: "",
      cost: "",
    };

    // Calculate total values
    const totalRow = {
      id: "total",
      type: "Total",
      ratePercent: "",
      rateValue: "",
      qtyPercent: "",
      qtyValue: mergedRows.reduce((sum, row) => {
        return row.type !== "Sub total" ? sum + (row.qtyValue || 0) : sum;
      }, 0),
      revValue: mergedRows.reduce((sum, row) => {
        return row.type !== "Sub total" ? sum + (row.revValue || 0) : sum;
      }, 0),
      revPercent: "",
      cost: "",
    };

    // Find and extract rows
    const baselineRow = mergedRows.find((row) => row.type === "Baseline");
    const correctionRow = mergedRows.find((row) => row.type === "Correction");
    const otherRows = mergedRows.filter(
      (row) => row.type !== "Baseline" && row.type !== "Correction"
    );

    // Reorder rows: Baseline -> Correction -> Rest
    const reorderedRows = [baselineRow, correctionRow, ...otherRows];

    // Append total row
    const formatedMergedRows = [
      ...reorderedRows.slice(0, 5),
      subtotalRow,
      ...reorderedRows.slice(5),
    ];
    const finalRows = [...formatedMergedRows, totalRow];

    setRows(finalRows);
    // setIsLoading(false);
    // setInitialLoad(false);
    // }, 300);

    // return () => {
    //   clearTimeout(timer);
    //   setRows([]);
    //   // setCallValue([]);
    //   // setIsLoading(true);
    //   // setInitialLoad(true);
    // };
  }, [open, editValue]);

  useEffect(() => {
    if (!open) {
      // Reset all relevant states when modal closes
      setRows([]);
    }
  }, [open]);

  useEffect(() => {
    const totalRev = rows
      .filter((row) => row.type !== "Total" && row.type !== "Sub total")
      .reduce((sum, row) => sum + (parseFloat(row.revValue) || 0), 0);
    const totalQty = rows
      .filter((row) => row.type !== "Total" && row.type !== "Sub total")
      .reduce((sum, row) => sum + (parseFloat(row.qtyValue) || 0), 0);

    setTotalRevValue(Math.round(totalRev));
    setTotalQtyValue(Math.round(totalQty));
  }, [rows]);

  const trackCorrectionValue = (newValue) => {
    setEnteredQtyImpact(newValue);
  };

  const processRowUpdate = (newRow, oldRow) => {
    // console.log(newRow.revValue, "newRow.revValue");
    // console.log(newRow.type === "Total", "Total");
    // console.log(newRow.field === "revValue", "revValue total");
    // console.log(newRow, "newRow.field");

    if (newRow.type === "Total") {
      setEditedTotalRevValue(newRow.revValue);
      setIsTotalRevEdited(true);

      // Force the row update right away
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.type === "Total" ? { ...row, revValue: newRow.revValue } : row
        )
      );
      return newRow;
    }

    {
      let qtyPercentValue = newRow.qtyPercent || "";

      // "%"
      if (!qtyPercentValue?.includes("%") && qtyPercentValue !== "") {
        qtyPercentValue = `${qtyPercentValue}`;
      }

      // Extract numeric value
      const correctionPercent =
        parseFloat(qtyPercentValue.replace("%", "")) || 0;

      // Find Baseline row
      const baselineRow = rows.find((row) => row.type === "Baseline");
      if (!baselineRow) {
        console.error("Baseline row not found.");
        return oldRow; // No updates
      }

      //  Correction Qty values
      const newCorrectionQtyValue =
        (parseFloat(baselineRow.qtyValue || 0) * correctionPercent) / 100;

      //  Correction Rev values
      const newCorrectionRevValue =
        newCorrectionQtyValue * baselineRow.rateValue;

      // Fix for Correction Rev %
      const newCorrectionRevPercent = baselineRow.revValue
        ? (newCorrectionRevValue / parseFloat(baselineRow.revValue || 1)) * 100
        : 0;

      // Fix for Correction Cost
      const newCorrectionCost =
        baselineRow.revValue && baselineRow.qtyValue && baselineRow.rateValue
          ? parseFloat(
              (
                parseFloat(baselineRow.revValue || 0) -
                (parseFloat(baselineRow.qtyValue || 0) +
                  parseFloat(newCorrectionQtyValue || 0)) *
                  parseFloat(baselineRow.rateValue || 0)
              ).toFixed(2)
            )
          : 0;

      newRow = {
        ...newRow,
        qtyPercent: qtyPercentValue,
        qtyValue: Math.round(newCorrectionQtyValue),
        revValue: Math.round(newCorrectionRevValue),
        revPercent: `${Math.round(newCorrectionRevPercent)}%`,
        cost: Math.round(newCorrectionCost),
      };
    }

    // Update rows with "Total"
    const updatedRows = rows.map((row) =>
      row.id === newRow.id ? newRow : row
    );

    // Calculate total values for `revValue` and `qtyValue`
    const totalRevValue = updatedRows
      .filter((row) => row.type !== "Total" && row.type !== "Sub total")
      .reduce((sum, row) => sum + (parseFloat(row.revValue) || 0), 0);

    const totalQtyValue = updatedRows
      .filter((row) => row.type !== "Total" && row.type !== "Sub total")
      .reduce((sum, row) => sum + (parseFloat(row.qtyValue) || 0), 0);

    // Update the "Total" row
    const updatedRowsWithTotal = updatedRows.map((row) =>
      row.type === "Total"
        ? {
            ...row,
            revValue: isTotalRevEdited
              ? editedTotalRevValue
              : totalRevValue.toFixed(2),
            qtyValue: totalQtyValue.toFixed(2),
          }
        : row
    );

    setRows(updatedRowsWithTotal);
    return newRow;
  };

  useEffect(() => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.type === "Total"
          ? {
              ...row,
              revValue: isTotalRevEdited
                ? editedTotalRevValue
                : totalRevValue?.toFixed(2),
            }
          : row
      )
    );

    const currentValue = isTotalRevEdited ? editedTotalRevValue : totalRevValue;

    setEditedMonthOutLook(currentValue);
  }, [
    totalRevValue,
    isTotalRevEdited,
    editedTotalRevValue,
    setEditedMonthOutLook,
  ]);

  const getRowsWithTotal = () => {
    return rows.map((row) =>
      row.type === "Total"
        ? {
            ...row,
            revValue: isTotalRevEdited ? editedTotalRevValue : totalRevValue,
            qtyValue: totalQtyValue,
          }
        : row
    );
  };
  const handleUpdate = async () => {
    setLoading(true);
    const baselineRow = rows.find((row) => row.type === "Baseline");
    const correctionRow = rows.find((row) => row.type === "Correction");
    var pricelist = "";
    var clikedDate = "M";
    //console.log("Page mname",page)
    if (page === "dayleveledit" || page === "daylevelchanneledit") {
      pricelist = callValue?.Pricelist ?? "";
      clikedDate = rowColumn;
    } else {
      pricelist = rowColumn?.includes("Pricelist") ? callValue?.Pricelist : "";

    }

    if (!baselineRow || !correctionRow) {
      console.error("Baseline or Correction row missing.");
      setLoading(false);
      return;
    }

    //  const clickedDate = event.colDef.field;

    // const validDate = clickedDate || "M";

    const payload = {
      Warehouse: callValue?.Warehouse,
      Channel: callValue?.OutletType,
      Pricelist: pricelist,
      ProductCode: callValue?.ProductCode??"",
      Date: clikedDate,
      enddayofmonth: "",
      startdayofmonth: getDatesFromMonthYearAsia(monthYear),
      rate: correctionRow.rateValue ? parseInt(correctionRow.rateValue) : 0,
      percentage: correctionRow.qtyPercent
        ? typeof correctionRow.qtyPercent === "string"
          ? parseInt(correctionRow.qtyPercent.replace("%", ""))
          : correctionRow.qtyPercent
        : 0,
      total: editedTotalRevValue,
      page: page,
      user: user,
      currencyType: currency,
      type:type??"Revenue"
    };

    try {
      const response = await api.post("/updatewitheditprocessnew", {
        body: payload,
      });
      setSnackbarAlertMessage(
        `Total revenue has been updated to ${editedTotalRevValue}.`
      );

      setSnackbarAlertSeverity("success");
      setSnackbarAlertOpen(true);

      updateRowData(response.data.data_updated);

      setTimeout(() => {
        handleClose();
      }, 300);
    } catch (error) {
      console.error("Error updating data:", error);
      setSnackbarAlertMessage("Failed to update data. Please try again.");
      setSnackbarAlertSeverity("error");
      setSnackbarAlertOpen(true);
    } finally {
      setLoading(false);
      setEditedTotalRevValue(null);
      setIsTotalRevEdited(false);
    }
  };

  const isCellEditable = (params) => {
    return (
      // (params.field === "qtyPercent" && params.row.type === "Correction") ||
      params.field === "revValue" && params.row.type === "Total"
    );
  };

  const [cellModesModel, setCellModesModel] = React.useState({});

  const handleCellClick = React.useCallback((params, event) => {
    if (!params.isEditable) {
      return;
    }

    // Ignore clicks outside the cell
    if (
      event.target.nodeType === 1 &&
      !event.currentTarget.contains(event.target)
    ) {
      return;
    }

    setCellModesModel((prevModel) => {
      return {
        // Revert the mode of the other cells from other rows
        ...Object.keys(prevModel).reduce(
          (acc, id) => ({
            ...acc,
            [id]: Object.keys(prevModel[id]).reduce(
              (acc2, field) => ({
                ...acc2,
                [field]: { mode: GridCellModes.View },
              }),
              {}
            ),
          }),
          {}
        ),
        [params.id]: {
          // Revert the mode of other cells in the same row
          ...Object.keys(prevModel[params.id] || {}).reduce(
            (acc, field) => ({ ...acc, [field]: { mode: GridCellModes.View } }),
            {}
          ),
          [params.field]: { mode: GridCellModes.Edit }, // Set clicked cell to edit mode
        },
      };
    });
  }, []);

  const handleCellModesModelChange = React.useCallback((newModel) => {
    setCellModesModel(newModel);
  }, []);

  const handleOpenNewTab = () => {
    const pricelist = rowColumn?.includes("Pricelist")
      ? callValue?.Pricelist
      : "";

    const filterUrl = `Warehouse=${callValue?.Warehouse}&Channel=${callValue?.OutletType}&Pricelist=${pricelist}&ProductCode=${callValue?.ProductCode}&monthYear=${monthYear}`;

    // Encode using Base64
    const base64EncodedUrl = btoa(filterUrl);
    // console.log(base64EncodedUrl, "Base64 Encoded URL");

    // Open in a new tab with the Base64-encoded URL
    window.open(`/current-month?encodedFilters=${base64EncodedUrl}`, "_blank");
  };

  const handleExportToExcel = async () => {
    const pricelist = rowColumn?.includes("Pricelist")
      ? callValue?.Pricelist
      : "";
    const payload = {
      Warehouse: callValue?.Warehouse,
      Channel: callValue?.OutletType,
      Pricelist: pricelist02 || pricelist,
      ProductCode: callValue?.ProductCode,
      Date: "M",
      startdayofmonth: getDatesFromMonthYearAsia(monthYear),
      user: user,
      currencyType: currency,
    };

    try {
      const response = await api.post("/api/getdetailsforalllines", {
        body: payload,
      });

      if (response.data.length > 0) {
        exportToExcel(response.data, "ExportedData");
      } else {
        console.log("No data to export");
      }
      setSnackbarMessage("Your data exported successfully.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setDataExport(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setSnackbarMessage("Failed to export data. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleCloseModal02 = () => {
    setNewSchemeModalOpen(false);
  };

  // if (!isLoading) {
  //   return (
  //     <Typography variant="h6" color="textSecondary">
  //       Loading...
  //     </Typography>
  //   );
  // }

  const theme = createTheme({
    components: {
      MuiDataGrid: {
        styleOverrides: {
          root: {
            fontSize: "14px", // Change this to your desired font size
          },
          columnHeaders: {
            fontSize: "14px", // Font size for column headers
          },
          row: {
            fontSize: "12px", // Font size for rows
          },
        },
      },
    },
  });

  // console.log(rows, "data grid summary edit data");
  // console.log(editedTotalRevValue, "editedTotalRevValue005");
  // console.log(totalRevValue, "totalRevValue005");

  return (
    <>
      {/* {!isDataAvailable ? (
      <Typography
        variant="h6"
        color="textSecondary"
        style={{ width: "100%", textAlign: "center", padding: "20px" }}
      >
        No data available
      </Typography>
    ) : ( */}
      <>
        <div style={{ width: "100%", minHeight: "350px" }}>
          <ThemeProvider theme={theme}>
            <DataGrid
              rows={getRowsWithTotal()}
              columns={columns}
              pagination={false}
              processRowUpdate={processRowUpdate}
              onProcessRowUpdateError={(error) => console.error(error)}
              isCellEditable={isCellEditable}
              experimentalFeatures={{ newEditingApi: true }}
              cellModesModel={cellModesModel}
              onCellModesModelChange={handleCellModesModelChange}
              onCellClick={handleCellClick}
              rowHeight={40}
              loading={isLoading}
              sx={{
                "& .MuiDataGrid-cell.MuiDataGrid-cell--editable": {
                  backgroundColor: "#AEF4EC", // Highlight editable fields
                  color: "#000",
                },
                "& .MuiDataGrid-cell.MuiDataGrid-cell--editable:focus-within": {
                  outline: "none",
                  backgroundColor: "#D8F7F1",
                },
                "& .MuiDataGrid-cell.MuiDataGrid-cell--editable input": {
                  fontSize: "12px",
                  color: "#000",
                  textAlign: "right",
                },
                "& .MuiCircularProgress-root": {
                  color: "#17A591",
                  width: "35px",
                  height: "35px",
                },
              }}
            />
          </ThemeProvider>
        </div>

        <section
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "20px",
          }}
        >
          <div
            style={{
              display: "flex",

              // width: "100%",
            }}
          >
            <div>
              <Button
                variant="contained"
                color="primary"
                onClick={handleExportToExcel}
                style={{
                  fontSize: "12px",
                  backgroundColor: "#16a695",
                  color: "white",
                  marginRight: "8px",
                }}
                size="small"
              >
                Export to Excel
              </Button>
            </div>

            {dayLevelButton && (
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleOpenNewTab}
                  style={{
                    fontSize: "12px",
                    backgroundColor: "#16a695",
                    color: "white",
                    marginRight: "8px",
                  }}
                  size="small"
                >
                  Day Level Edits
                </Button>
              </div>
            )}
          </div>

          <div>
            <LoadingButton
              variant="contained"
              color="primary"
              disabled={(() => {
                // console.log("Comparing:", editedTotalRevValue, totalRevValue);
                return (
                  editedTotalRevValue === null ||
                  String(editedTotalRevValue).trim() ===
                    String(totalRevValue).trim()
                );
              })()}
              onClick={handleUpdate}
              loading={loading}
              loadingPosition="end"
              style={{
                backgroundColor: loading ? "#16a69590" : "#16a695",
                paddingRight: loading ? "35px" : "",
                // opacity: !isQtyPercentEdited ? 0.5 : 1,
                // pointerEvents: !isQtyPercentEdited ? "none" : "auto",
                opacity:
                  editedTotalRevValue === null ||
                  String(editedTotalRevValue).trim() ===
                    String(totalRevValue).trim()
                    ? 0.5
                    : 1,
                pointerEvents:
                  editedTotalRevValue === null ||
                  String(editedTotalRevValue).trim() ===
                    String(totalRevValue).trim()
                    ? "none"
                    : "auto",

                color: "white",
                marginRight: "8px",
              }}
              size="small"
              sx={{
                fontSize: "12px",
              }}
            >
              {loading ? "Updating..." : "Update"}
            </LoadingButton>

            <Button
              variant="outlined"
              onClick={() => {
                handleClose();
                handleClearNewValues();
              }}
              style={{ color: "#000", borderColor: "#707070" }}
              size="small"
              sx={{
                fontSize: "12px",
              }}
            >
              Cancel
            </Button>
          </div>
        </section>
      </>
      {/* )} */}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default DataGridWithEdit;
